module.exports = __webpack_public_path__ + "static/media/ONE-BUSD.d81eef6a.svg";